function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 346.043 346.043",
  style: {
    "enableBackground": "new 0 0 346.043 346.043"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#00EFD1"
  },
  points: "241.553,131.329 241.553,214.921 107.806,214.921 107.806,272.39 10.631,173.125  107.806,73.86 107.806,131.329 \t"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#083863"
  },
  d: "M107.806,282.839c-2.756-0.039-5.385-1.166-7.314-3.135L2.794,180.439 c-3.725-4.165-3.725-10.464,0-14.629l97.698-99.265c2.928-3.155,7.49-4.192,11.494-2.612c3.75,1.911,6.155,5.719,6.269,9.927 v47.02h123.298c2.796-0.167,5.507,0.995,7.314,3.135c1.969,1.929,3.095,4.558,3.135,7.314v83.592 c0,5.771-4.678,10.449-10.449,10.449H118.255v47.02c-0.115,4.207-2.52,8.015-6.269,9.927L107.806,282.839z M25.259,173.125 l72.098,73.665v-31.869c0-5.771,4.678-10.449,10.449-10.449h123.298v-62.694H107.806c-5.771,0-10.449-4.678-10.449-10.449V99.46 L25.259,173.125z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#083863"
  },
  d: "M272.9,120.88L272.9,120.88c5.771,0,10.449,4.678,10.449,10.449v83.592 c0,5.771-4.678,10.449-10.449,10.449l0,0c-5.771,0-10.449-4.678-10.449-10.449v-83.592 C262.451,125.558,267.129,120.88,272.9,120.88z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#083863"
  },
  d: "M304.247,120.88L304.247,120.88c5.771,0,10.449,4.678,10.449,10.449v83.592 c0,5.771-4.678,10.449-10.449,10.449l0,0c-5.771,0-10.449-4.678-10.449-10.449v-83.592 C293.798,125.558,298.476,120.88,304.247,120.88z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#083863"
  },
  d: "M335.594,120.88L335.594,120.88c5.771,0,10.449,4.678,10.449,10.449v83.592 c0,5.771-4.678,10.449-10.449,10.449l0,0c-5.771,0-10.449-4.678-10.449-10.449v-83.592 C325.145,125.558,329.823,120.88,335.594,120.88z"
}))));

export default __webpack_public_path__ + "static/media/arrowLEFT.2b75bf5b.svg";
export { SvgComponent as ReactComponent };